export const environment = {
  /** Name of this environment */
  name: "dev",

  /** URL for the API REST server */
  apiUrl: "https://chc6gdyz6h.execute-api.us-east-1.amazonaws.com/prod",

  /** Time before a page loading spinner appears */
  pageLoaderTime: 300,

	/** Survey JS License */
	surveyJSLicense: "ODA4N2Q5NDUtNWVkNS00NDU4LWI5ZDgtMDhlMjEyODVkNzBlOzE9MjAyNi0wOS0wMg==",

	/** Enabled languages that can be selected in the survey (for now, just enable english and spanish) */
	enabledLanguages: ['en', 'es'],

	/** Default language to set the surveys in */
	defaultLanguage: 'en'
};
